var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondWinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3690_17716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52944 5.69082C11.0583 5.69082 12.5246 6.29817 13.6057 7.37926C14.6868 8.46035 15.2941 9.92663 15.2941 11.4555C15.2941 12.9844 14.6868 14.4507 13.6057 15.5318C12.5246 16.6129 11.0583 17.2202 9.52944 17.2202C8.00055 17.2202 6.53427 16.6129 5.45318 15.5318C4.37209 14.4507 3.76474 12.9844 3.76474 11.4555C3.76474 9.92663 4.37209 8.46035 5.45318 7.37926C6.53427 6.29817 8.00055 5.69082 9.52944 5.69082ZM9.52944 8.21288L8.57611 10.1441L6.44533 10.4539L7.98738 11.9563L7.62349 14.0792L9.52944 13.0768L11.4354 14.0785L11.0715 11.9563L12.6136 10.4532L10.4828 10.1433L9.52944 8.21288ZM10.25 2.08716L13.853 2.08788V4.24964L12.8708 5.06967C12.0558 4.64206 11.1659 4.37563 10.25 4.28495V2.08788V2.08716ZM8.80886 2.08716V4.28495C7.89324 4.37549 7.00365 4.64168 6.1888 5.06895L5.20591 4.24964V2.08788L8.80886 2.08716Z",
    fill: "#004EE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3690_17716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2941,
    height: 17.2941,
    fill: "white",
    transform: "translate(0.882385 0.646606)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondWinner);
export default __webpack_public_path__ + "static/media/second-winner.eebf2d3bf6d7ff1f1678edec2734bb8c.svg";
export { ForwardRef as ReactComponent };